/**
 * API Constants
 * Central location for all API-related constants
 */

const BETA = true;
let BASE_URL = 'https://server.qmin.co.in';
let MARKETPLACE_REFERENCE_ID = '70799f66a3ae35a7a90718814a00a9b8';
let redirectUrl = "https://order.qmin.co.in"
if(BETA){
  BASE_URL= 'https://server-tata.yelo.solutions',
  MARKETPLACE_REFERENCE_ID = '79a3d146032d444853393bc4b4df35e4',
  redirectUrl = "https://tatadigital.com"
}

export const creds = {
  BETA,
  redirectUrl,
}
export const API = {
  BASE_URL: BASE_URL,
  PAYMENT_BASE_URL: 'https://payment.qmin.co.in',
  ENDPOINTS: {
    MARKETPLACE_CONFIG: '/marketplace_fetch_app_configuration',
    BUSINESS_CATEGORIES: '/businessCategory/getCategory',
    PARENT_BUSINESS_CATEGORIES: '/businessCategory/parent/getCategory',
    GET_PRODUCTS_FOR_BUSINESS_CATEGORY: '/get_products_for_business_category',
    MARKETPLACE_GET_CITY_STOREFRONT_V3: '/marketplace/marketplace_get_city_storefronts_v3',
    BANNERS: '/banner/getBanner',
    // Add other endpoints as needed
    RESTAURANTS: '/restaurants',
    MARKETPLACE_STOREFRONTS: '/marketplace/marketplace_get_city_storefronts_v3',
    MENU: '/menu/active',
    ORDERS: '/orders',
    USER_PROFILE: '/user/profile',
    // Search endpoints
    SEARCH_PRODUCTS: '/search/global/product',
    SEARCH_MERCHANTS: '/search/global/merchants',
    // Auth endpoints
    CHECK_PHONE: '/tata/check-phone',
    VERIFY_PHONE_OTP: '/tata/verify-phone-otp',
    RESEND_OTP: '/tata/resend-otp',
    SSO_AUTHENTICATE: '/tatanew/sso/authenticate',
    MARKETPLACE_VENDOR_LOGIN: '/marketplace_vendor_login_via_access_token',
    CATALOGUE : '/catalogue/getFullHierarchy',
    GET_SERVICE_JOB_HISTORY: '/get_service_job_history',
    GET_FAV_LOCATION : '/get_fav_location',
    ADD_FAV_LOCATION: '/add_fav_location',
    EDIT_FAV_LOCATION: '/edit_fav_location',
    DELETE_FAV_LOCATION: '/delete_fav_location',
    GET_BILL_BREAKDOWN : '/get_bill_breakdown',
    CREATE_TASK : '/create_task_via_vendor_v2',
    QWIKCILVER : '/qwikcilver/balanceEnquiry',
    CREATE_TASK_V2: '/create_task_via_vendor_v2',
    ORDER_SERVICEABLE_CHECK: '/order/serviceableCheck',
    GET_PAYMENT_URL: '/payment/getPaymentUrl',
    TIMESLOT: '/timeSlot/getStorefrontTimeslotsV2'
  },
  MARKETPLACE_REFERENCE_ID: MARKETPLACE_REFERENCE_ID,
  SECRET: "+1206-257-2964"
};
